import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from 'gatsby'

// Components
import Container from '../../Container'
import Spacer from '../../Spacer'
import Button from '../../Button'
import RichText from '../../RichText'
import AnimateSlideText from '../../animation/AnimateSlideText'

// Styles
import { MapHeader, MapText } from './index.style'
import PageTransitionLink from '../../PageTransitionLink'

const MapIntro = ({ id, heading, text, link }) => {
  const {
    site: {
      siteMetadata: { routes },
    },
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          routes {
            home
            expeditions
            itinerary
          }
        }
      }
    }
  `)

  return (
    <MapHeader inView={true}>
      <Container>
        <Spacer size={[80, 116]} />
        <RichText
          id={`${id}-heading`}
          content={heading}
          forceHeading
          delayEm={true}
        />
        <Spacer size={[18, 28]} />
        <MapText>
          <RichText id={`${id}-text`} content={text} />
        </MapText>
        <Spacer size={[38, 48]} />
        <AnimateSlideText id={`${id}-cta`}>
          <PageTransitionLink to={routes.itinerary} mask={false}>
            <Button inline variant="underline">
              {link}
            </Button>
          </PageTransitionLink>
        </AnimateSlideText>
        <Spacer size={80} />
      </Container>
    </MapHeader>
  )
}

MapIntro.propTypes = {
  id: PropTypes.string.isRequired,
  heading: PropTypes.object.isRequired,
  text: PropTypes.object,
  link: PropTypes.string,
}

export default MapIntro
